"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ie11Mixin = void 0;
var _styledComponents = require("styled-components");
/** @mixin ie11Mixin */
/**
 * Only render the given styles in IE11.
 *
 * @example
 * import { ie11Mixin } from '@zillow/constellation';
 *
 * const ie11Styles = css`
 *     color: red;
 * `;
 *
 * const Component = styled.div`
 *     color: blue;
 *     ${ie11Mixin(ie11Styles)}
 * `;
 *
 * <Component>The text is red in IE11, blue otherwise</Component>
 *
 * @method
 * @param {CSSObject} styles - A styled-compoennts css object.
 * @return {CSSObject}
 */
var ie11Mixin = function ie11Mixin(styles) {
  return function () {
    return (0, _styledComponents.css)(["_:-ms-fullscreen &,&{", "}"], styles);
  };
};
exports.ie11Mixin = ie11Mixin;